import React, {useState} from 'react'
import { fade, makeStyles } from '@material-ui/core/styles';
import { Box, Divider, Grid, Typography, TextField, Button } from '@material-ui/core';
import authentication from "../../../services/authentication";
import * as Yup from 'yup';
import { Formik, useFormik, yupToFormErrors } from 'formik';
import Loader from '../../Loader';
import language from '../../../languages';

const useStyles = makeStyles((theme) => ({
    divider: {
        backgroundColor:"#2735A4",
        height: 2
    },
    inputGrid: {
        margin: '20px 0px'
    },
    saveButton: {
      color: '#ffffff',
      backgroundColor: '#3076CA',
      '&:hover': {
        backgroundColor: fade('#3076CA', 0.75),
      },
      margin: '8px 8px;',
      padding: '6px 30px',
      textTransform: 'capitalize'
    },
    inputLabel: {
        color: '#09205C'
    }
}));

export default function ChangePassword(props) {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const { appSettings } = props
    
    const lang = appSettings ? (appSettings.language ? appSettings.language: 'en') : 'en';

    function handleSubmit(passwordResetForm) {
      
        authentication
                .changePassword(passwordResetForm.newPassword)
                .then((user) => {
                    setLoading(false)
                    props.openSnackbar(
                      `${language[lang].Password_changed_successfully}`, 'success'
                    );
                })
                .catch((reason) => {
                  const code = reason.code;
                  const message = reason.message;
                  setLoading(false)
    
                  switch (code) {
                    case "auth/invalid-email":
                    case "auth/user-disabled":
                    case "auth/user-not-found":
                    case "auth/wrong-password":
                      props.openSnackbar(message, 'error');
                      return;
    
                    default:
                      props.openSnackbar(message, 'error');
                      return;
                  }
                })
                .finally(() => {
                //   this.setState({
                //     performingAction: false,
                //   });
                });
      }

    const validationSchema = Yup.object({
        oldPassword: Yup
            .string()
            .required(language[lang].Field_Required),
        newPassword: Yup
        .string()
        .required(language[lang].Field_Required)
        .matches(
            "^.{6,}$",
            language[lang].Password_Criteria
            ),
        confirmPassword: Yup
            .string()
            .required(language[lang].Field_Required)
            .oneOf([Yup.ref("newPassword"), null], language[lang].Password_Match)
    })
    
    const initialPasswordResetForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword : ''
    }
    
    const formik = useFormik({
        initialValues: initialPasswordResetForm,
        enableReinitialize:true,
        validationSchema: validationSchema || Yup.object({}),
        onSubmit: passwordResetForm => {
            setLoading(true)
            handleSubmit(passwordResetForm)
        },
    });

    return (
        <Box mb={12} mt={8}>
            <Divider className={classes.divider} />
            <Box p={4}>
                { loading ? <Loader /> : 
                <Grid container>
                    <Grid item xs={12} sm={8} md={6} lg={5}>
                    <form onSubmit={formik.handleSubmit} >
                        <Grid container justify="flex-start" alignItems="center" className={classes.inputGrid}>
                            <Grid item xs={4}>   
                                <Typography variant="subtitle2" className={classes.inputLabel}>{language[lang].Old_Password}</Typography>
                            </Grid>
                            <Grid item xs={1} ></Grid>
                            <Grid item xs={7}>   
                                <TextField 
                                    variant="outlined"
                                    className={classes.singnUpInput}
                                    id='oldPassword'
                                    value={formik.values.oldPassword}
                                    name='oldPassword'
                                    type="password"
                                    size="small"
                                    {...formik.getFieldProps('oldPassword')}
                                    error={formik.touched.oldPassword && Boolean(formik.errors.oldPassword)}
                                    helperText={formik.errors.oldPassword}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                        </Grid>
                        <Grid container justify="flex-start" alignItems="center" className={classes.inputGrid}>
                            <Grid item xs={4}>   
                                <Typography variant="subtitle2" className={classes.inputLabel}>{language[lang].New_Password}</Typography>
                            </Grid>
                            <Grid item xs={1} ></Grid>
                            <Grid item xs={7}>   
                                <TextField 
                                    variant="outlined"
                                    className={classes.singnUpInput}
                                    id='newPassword'
                                    value={formik.values.newPassword}
                                    name='newPassword'
                                    type="password"
                                    size="small"
                                    {...formik.getFieldProps('newPassword')}
                                    error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
                                    helperText={formik.errors.newPassword}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                        </Grid>
                        <Grid container justify="flex-start" alignItems="center" className={classes.inputGrid}>
                            <Grid item xs={4}>   
                                <Typography variant="subtitle2" className={classes.inputLabel}>{language[lang].Confirm_Password}</Typography>
                            </Grid>
                            <Grid item xs={1} ></Grid>
                            <Grid item xs={7}>   
                                <TextField 
                                    variant="outlined"
                                    className={classes.singnUpInput}
                                    id='confirmPassword'
                                    value={formik.values.confirmPassword}
                                    name='confirmPassword'
                                    type="password"
                                    size="small"
                                    {...formik.getFieldProps('confirmPassword')}
                                    error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                                    helperText={formik.errors.confirmPassword}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                        </Grid>
                        <Button variant='contained' type='submit' className={classes.saveButton} >{language[lang].Save}</Button>
                    </form>
                    </Grid>
                </Grid>
                }
            </Box>
        </Box>
    )
}